export const RefCode = {
  key: 'ref_code',
  get() {
    return localStorage.getItem(this.key) || '';
  },
  set(value) {
    if (this.get()) {
      return;
    }
    return localStorage.setItem(this.key, value);
  }
};
